import { render, staticRenderFns } from "./graphPizza-new-ux.vue?vue&type=template&id=4da2b87a&"
import script from "./graphPizza-new-ux.vue?vue&type=script&lang=js&"
export * from "./graphPizza-new-ux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4da2b87a')) {
      api.createRecord('4da2b87a', component.options)
    } else {
      api.reload('4da2b87a', component.options)
    }
    module.hot.accept("./graphPizza-new-ux.vue?vue&type=template&id=4da2b87a&", function () {
      api.rerender('4da2b87a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/graphPizza-new-ux.vue"
export default component.exports